/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import Material_React_Table from '../../components/Material_React_Table';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Box } from '@mui/material';

export default function AddTenantAdmin(props) {
  const { api } = useContext(FirebaseContext);
  const {
    updateProfile,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
  } = api;
  const [state, setState] = useState({
    userType: "tenant",
    firstName: "",
    lastName: "",
    username: "",
    identityNumber: "",
    referralId: "",
    practiceNumber: "",
    practiceName: "",
    practiceLicenseNumber: "",
    specialityType: "Default",
    bankAccount: "",
    bankCode: "",
    bankName: "",
    bankType: "",
    licenseImage: null,
    brokerImage: null,
    landlordImage: null,
    other_info: "",
    password: "",
    email: "",
  });
  const [isdepdata, setIsdepData] = useState({
    isIndependent: false,
  });
  // const specialities = useSelector(
  //   (state) => state.specialitytypes.specialities
  // );
  const [specialityTypes, setSpecialityTypes] = useState({});
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState([]);
  const usersdata = useSelector((state) => state.usersdata);
  const [Newdata, setNewData] = useState([]);
  const dispatch = useDispatch();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const columns = [
    {id: 'id', // Group for Employee-related columns
      header: 'Hidden id',
      columns: [
        {
          accessorKey: 'id',
          header: 'User id',
          enableEditing: false,
          Edit: () => null, //don't render anything in the editing modal for this column
          //or Edit: ({ cell, renderedCellValue }) => <>{renderedCellValue}</>, //render the normal cell value instead of a text field
          enableHiding: true,
        },
      ]
    },
    {
      id: 'TenantDetails', // Group for Tenant-related columns
      header: 'Tenant Details',
      columns: [
        {
          accessorKey: 'firstName', // First Name column
          header: language.first_name,
        },
        {
          accessorKey: 'lastName', // Last Name column
          header: language.last_name,
        },
        {
          accessorKey: 'username', // Username column
          header: language.username,
        },
        {
          accessorKey: 'identityNumber', // Identity Number column
          header: 'Identity Number',
        },
        {
          accessorKey: 'email', // Email column with conditional editing
          header: language.email,
          enableEditing: features.AllowCriticalEditsAdmin,
          Cell: ({ cell }) =>
            features.AllowCriticalEditsAdmin ? (
              cell.getValue()
            ) : (
              <span style={{ color: 'gray' }}>Hidden for Demo</span>
            ),
        },
        {
          accessorKey: 'mobile', // Mobile column with conditional editing
          header: language.mobile,
          enableEditing: features.AllowCriticalEditsAdmin,
          Cell: ({ cell }) =>
            features.AllowCriticalEditsAdmin ? (
              cell.getValue()
            ) : (
              <span style={{ color: 'gray' }}>Hidden for Demo</span>
            ),
        },
        {
          accessorKey: 'referralId', // Referral ID column
          header: 'Referral ID',
        },
        {
          accessorKey: 'userType', // User Type column
          header: 'User Type',
        },
        {
          accessorKey: 'walletBalance', // Wallet Balance column
          header: 'Wallet Balance',
          Cell: ({ cell }) => `$${cell.getValue()}`,
        },
        {
          accessorKey: 'practiceAdminActiveStatus', // Approval column with conditional styling
          header: language.account_approve,
          enableEditing: true,
          Cell: ({ cell }) => (
            <span
              style={{
                color: cell.getValue() ? 'green' : 'orange',
                fontWeight: 'bold',
              }}
            >
              {cell.getValue() ? 'Approved' : 'Pending'}
            </span>
          ),
        },
      ],
    },
    // {
    //   id: 'DeviceDetails', // Group for Device-related columns
    //   header: 'Device Details',
    //   columns: [
    //     {
    //       accessorKey: 'deviceInfo.Brand', // Device Brand column
    //       header: 'Brand',
    //     },
    //     {
    //       accessorKey: 'deviceInfo.Model', // Device Model column
    //       header: 'Model',
    //     },
    //     {
    //       accessorKey: 'deviceInfo.deviceName', // Device Name column
    //       header: 'Device Name',
    //     },
    //     {
    //       accessorKey: 'deviceInfo.deviceOSname', // OS Name column
    //       header: 'OS Name',
    //     },
    //     {
    //       accessorKey: 'deviceInfo.deviceOSversion', // OS Version column
    //       header: 'OS Version',
    //     },
    //     {
    //       accessorKey: 'deviceInfo.devicemodelid', // Model ID column
    //       header: 'Model ID',
    //     },
    //   ],
    // },
    {
      id: 'AdditionalDetails', // Group for Additional columns
      header: 'Additional Details',
      columns: [
        {
          accessorKey: 'id', // Unique ID column
          header: 'ID',
        },
        {
          accessorKey: 'createdAt', // Created At column
          header: 'Created At',
          Cell: ({ cell }) =>
            new Date(cell.getValue()).toLocaleDateString('en-US'),
        },
        {
          accessorKey: 'password', // Password column
          header: 'Password',
          enableEditing: features.AllowCriticalEditsAdmin,
          Cell: ({ cell }) =>
            features.AllowCriticalEditsAdmin ? (
              cell.getValue()
            ) : (
              <span style={{ color: 'gray' }}>Hidden for Demo</span>
            ),
        },
        {
          accessorKey: 'pushToken', // Push Token column
          header: 'Push Token',
        },
      ],
    },
  ];
  

  const  onRowAdd= (AddData) =>{
    console.log("newData", AddData) ;

    new Promise((resolve, reject) => {
      setTimeout(() => {
        checkUserExists(AddData).then((res) => {
          if (res.users && res.users.length > 0) {
            alert(language.user_exists);
            reject();
          } else if (res.error) {
            alert(language.email_or_mobile_issue);
            reject();
          } else {
            AddData["createdByAdmin"] = true;

            AddData["userType"] = "tenant";
            AddData["createdAt"] = new Date().toISOString();
            AddData["referralId"] =
            AddData.firstName.toLowerCase() +
              Math.floor(1000 + Math.random() * 9000).toString();
            setState({
              ...state,
              AddData,
            });
            AddData["username"] =
            AddData.firstName.toLowerCase() +
            AddData.lastName.toLowerCase() +
              Math.floor(1000 + Math.random() * 9000).toString();
            setState({
              ...state,
              AddData,
            });
            let role = auth.info.profile.userType;
            if (role === "tenant") {
              AddData["tenant"] = auth.info.uid;
            }
            console.log("AddData before dispatch", AddData);
            
           
            emailSignUp(AddData).then((res) => {
              resolve();
              console.log("i am the back data", res);
              if (res.uid) {
                setTimeout(() => {
                  setCommonAlert({
                    open: true,
                    msg: language.account_create_successfully,
                  });
                  // props.history.push("/login");
                  console.log(AddData);
                }, 3000);
              } else {
                setCommonAlert({
                  open: true,
                  msg: language.reg_error,
                });
              }
            });
          }
        });
      }, 600);
    });
  };

    const onRowDelete =(oldData) =>{
      features.AllowCriticalEditsAdmin
        ? new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              dispatch(deleteUser(oldData.id));
            }, 600);
          })
        : new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              alert(language.demo_mode);
            }, 600);
          });
        };

    const onRowUpdate= (newData) =>{
      new Promise((resolve) => {
        setTimeout(() => {
          resolve();
          dispatch(editUser(newData.id, newData));
        }, 600);
      });
    };

  // const columns = [
  //   { title: language.first_name, field: "firstName", initialEditValue: "" },
  //   { title: language.last_name, field: "lastName", initialEditValue: "" },
  //   { title: "Identity Number", field: "identityNumber", initialEditValue: "" },

  //   {
  //     title: language.email,
  //     field: "email",
  //     editable: "onAdd",
  //     render: (rowData) =>
  //       features.AllowCriticalEditsAdmin ? rowData.email : "Hidden for Demo",
  //   },
  //   { title: "password", field: "password", initialEditValue: "" },
  //   {
  //     title: language.mobile,
  //     field: "mobile",
  //     editable: "onAdd",
  //     render: (rowData) =>
  //       features.AllowCriticalEditsAdmin ? rowData.mobile : "Hidden for Demo",
  //   },

  //   {
  //     title: language.account_approve,
  //     field: "practiceAdminActiveStatus",
  //     type: "boolean",
  //     initialEditValue: true,
  //   },
  // ];

  const mockData = [
    { firstName: "John", lastName: "Doe", identityNumber: "12345", email: "john.doe@example.com" },
    { firstName: "Jane", lastName: "Smith", identityNumber: "67890", email: "jane.smith@example.com" },
  ];
  
  const mockColumns = [
    { accessorKey: 'firstName', header: 'First Name' },
    { accessorKey: 'lastName', header: 'Last Name' },
    { accessorKey: 'identityNumber', header: 'Identity Number' },
    { accessorKey: 'email', header: 'Email' },
  ];
  
  useEffect(() => {
    if (usersdata.users) {
      setData(
        usersdata.users.filter(
          (user) => user.userType === "tenant"
          // user.practiceNumber === auth.info.profile.practiceNumber
        )
      );
    } else {
      setData(usersdata.users);
    }
  }, [usersdata.users]);
  console.log("user: ", data);
  
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

 return usersdata.loading ? (
    <CircularLoading />
  ) : (
    (
    (
      <>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
   
        <Material_React_Table
          data={data}
          columns={columns}
          userInitialState={{
            columnVisibility: { id: false }, // This hides the "id" column initially
          }}
          onRowAdd={onRowAdd}
          onRowUpdate={onRowUpdate}
          onRowDelete={onRowDelete}
        />
      </>
    </LocalizationProvider>
    </>
    ))
  );
}
